// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"455":"0c201686","977":"f255d80a"}[chunkId] + ".chunk.js";
};